import { HvacGroup } from '@belimo-retrofit-portal/logic';
import { createStructuredSelector } from 'reselect';
import { getHvacSchemaAirHandler } from 'src/modules/hvac/selectors/getHvacSchemaAirHandler';
import { getHvacSchemaDistribution } from 'src/modules/hvac/selectors/getHvacSchemaDistribution';
import { getHvacSchemaEmission } from 'src/modules/hvac/selectors/getHvacSchemaEmission';
import { getHvacSchemaGeneration } from 'src/modules/hvac/selectors/getHvacSchemaGeneration';

export const getHvacSchema = createStructuredSelector({
  [HvacGroup.EMISSION]: getHvacSchemaEmission,
  [HvacGroup.GENERATION]: getHvacSchemaGeneration,
  [HvacGroup.DISTRIBUTION]: getHvacSchemaDistribution,
  [HvacGroup.AIR_HANDLER]: getHvacSchemaAirHandler,
});
